module.exports = __webpack_public_path__ + "img/e1.c2f89056.jpg";